import React from 'react';

const ScreenshotPreview = ({ label, screenshot, onClick }) => (
    <div
        role="button"
        tabIndex={0}
        onClick={onClick}
        onKeyDown={(event) => {
            if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault();
                onClick();
            }
        }}
        style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: '8px',
            cursor: 'pointer',
            outline: 'none'
        }}
    >
        <div style={{
            backgroundColor: '#2d2d2d',
            border: '1px solid #404040',
            borderRadius: '6px',
            padding: '12px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            transition: 'transform 0.2s'
        }}
            onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'scale(1.02)';
            }}
            onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'scale(1)';
            }}
        >
            <img
                src={`data:image/png;base64,${screenshot}`}
                alt={`${label} screenshot`}
                style={{
                    maxWidth: '180px',
                    maxHeight: '220px',
                    width: 'auto',
                    height: 'auto',
                    borderRadius: '4px',
                    objectFit: 'contain'
                }}
            />
        </div>
        <div style={{
            fontSize: '12px',
            color: '#a0a0a0',
            textTransform: 'uppercase',
            letterSpacing: '0.5px'
        }}>
            {label}
        </div>
    </div>
);

export default ScreenshotPreview;






